import React, { createContext, useCallback, useMemo, useState } from 'react';
import NewGenericEventModal from '@features/Modals/NewGenericEventModal';
import EditGenericEventModal from '@features/Modals/EditGenericEventModal';
import VisitEditModal from '../features/Modals/VisitModal';
import TimeOffModal from '../features/Modals/TimeOffModal';
export const ModalContext = createContext(undefined);
export function ModalContextProvider(params) {
    const [modifiedEventWatch, setModifiedEventWatch] = useState(null);
    const [modifiedEventsWatch, setModifiedEventsWatch] = useState(null);
    const [createdEventsWatch, setCreatedEventsWatch] = useState(null);
    const [deletedEventsWatch, setDeletedEventsWatch] = useState(null);
    const [activeModal, setActiveModal] = useState(null);
    const openVisitModal = useCallback((id) => {
        setActiveModal(React.createElement(VisitEditModal, { id: id, onClose: () => {
                setActiveModal(null);
            }, onSave: (updatedVisit) => {
                setModifiedEventWatch(updatedVisit);
                setActiveModal(null);
            } }));
    }, []);
    const openTimeOffModal = useCallback((id) => {
        setActiveModal(React.createElement(TimeOffModal, { id: id, onClose: () => {
                setActiveModal(null);
            } }));
    }, []);
    const openNewGenericEventModal = useCallback((modalParams) => {
        setActiveModal(React.createElement(NewGenericEventModal
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, modalParams, { onClose: () => {
                setActiveModal(null);
            }, onSave: (genericEvents) => {
                setActiveModal(null);
                setCreatedEventsWatch(genericEvents);
            } })));
    }, []);
    const openEditGenericEventModal = useCallback((id) => {
        setActiveModal(React.createElement(EditGenericEventModal, { id: id, onClose: () => {
                setActiveModal(null);
            }, onDelete: (genericEvents) => {
                setActiveModal(null);
                setDeletedEventsWatch(genericEvents);
            }, onSave: (genericEvents) => {
                setModifiedEventsWatch(genericEvents);
            } }));
    }, []);
    const contextData = useMemo(() => {
        const value = {
            activeModal,
            openVisitModal,
            openTimeOffModal,
            modifiedEventWatch,
            createdEventsWatch,
            deletedEventsWatch,
            modifiedEventsWatch,
            openNewGenericEventModal,
            openEditGenericEventModal
        };
        return value;
    }, [activeModal, modifiedEventWatch, createdEventsWatch, modifiedEventsWatch, deletedEventsWatch]);
    return React.createElement(ModalContext.Provider, { value: contextData }, params.children);
}
